(function(){
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @param   object block The block element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	var initializeBlock = function( block ) {
		const dropdown = block.querySelector('.movie-programs-block__dropdown')

		if (dropdown) {
			dropdown.addEventListener('change', function(event) {
				const elements = block.querySelectorAll('.movie-programs-block__program-month')
				const selector = event.target.options[event.target.selectedIndex].value;

				if (selector) {
					elements.forEach(function(element) {
						element.style.display = "none";
					});

					const selectedSection = block.querySelector(selector);

					if (selectedSection) {
						selectedSection.style.display = "block";
					}
				} else {
					elements.forEach(function(element) {
						element.style.display = "block";
					});
				}
			});
		}
	}

	// Initialize each block on page load (front end).
	window.addEventListener('DOMContentLoaded', function() {
		const blocks = document.querySelectorAll('.movie-programs-block');

		blocks.forEach(function(blockElement) {
			initializeBlock(blockElement);
		});
	});

	// Initialize dynamic block preview (editor).
	if ( window.acf ) {
		window.acf.addAction( 'render_block_preview/type=movie-programs', function(blocks) {
			for (let i = 0; i < blocks.length; i++) {
				let block = blocks[i];

				initializeBlock(block);
			}
		} );
	}
})();
